import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, CardBody, Row, Col } from "reactstrap";
import { metadataService } from "../../_services";
import PropTypes from "prop-types";
import { SlBusyIndicator, SLDetailsTable, SlSectionTitle } from "../editors";
import {FinancialDetails} from "./FinancialDetails"

class ViewProfile extends Component {
  constructor() {
    super();
  }

  render() {
    const {
      fullName,
      address1,
      city,
      state,
      postalCode,
      email,
      mobilePhone,
      monthsAtResidence,
      yearsAtResidence,
      ownResidence,
      residenceType,
      monthlyResidencePayment,
      employers,
      incomes,
    } = this.props.profile;
    const { profileLoaded } = this.props;
    return (
      <div>
        {" "}
        {profileLoaded && (
          <div>
            <SlSectionTitle sectionName="My_Info" />
            <Card>
              <CardBody className={"p-0 m-0"}>
                <SLDetailsTable
                  dataSource={[
                    fullName && {
                      label: metadataService.getFieldNameLabel("Name"),
                      value: fullName,
                    },
                    address1 && {
                      label: metadataService.getFieldNameLabel("Address"),
                      value: address1,
                    },
                    city && {
                      label: metadataService.getFieldNameLabel("City"),
                      value: city,
                    },
                    state && {
                      label: metadataService.getFieldNameLabel("State"),
                      value: state,
                    },
                    postalCode && {
                      label: metadataService.getFieldNameLabel("Zip"),
                      value: postalCode,
                    },
                    email && {
                      label: metadataService.getFieldNameLabel("Email"),
                      value: email,
                    },
                    mobilePhone && {
                      label: metadataService.getFieldNameLabel("MobileNumber"),
                      value: metadataService.formatPhoneNumber(mobilePhone),
                    },
                    yearsAtResidence && {
                      label: metadataService.getFieldNameLabel("Years"),
                      value: yearsAtResidence,
                    },
                    monthsAtResidence && {
                      label: metadataService.getFieldNameLabel("Months"),
                      value: monthsAtResidence,
                    },
                    (residenceType !== null) && {
                      label: metadataService.getFieldNameLabel("ResidenceType"),
                      value: metadataService.getLookupText("residenceType",residenceType),
                    },
                    // ownResidence != null && {
                    //   label: metadataService.getFieldNameLabel("RentOrOwn"),
                    //   value:
                    //     ownResidence === false
                    //       ? metadataService.getLabel("Rent")
                    //       : metadataService.getLabel("Own"),
                    // },
                    residenceType !== metadataService.ENUM_RESIDENCE_TYPE.OWN &&
                      monthlyResidencePayment && {
                        label: metadataService.getFieldNameLabel(
                          "MonthlyResidencePayment"
                        ),
                        value: metadataService.formatMoney(
                          monthlyResidencePayment
                        ),
                      },
                  ]}
                />
                <Row className="mt-0">
                  <Col xs={12} className="text-right">
                    <small
                      className="cursor-pointer"
                      title={metadataService.getButton("ClickToEdit")}
                      onClick={this.props.onRequestEdit}
                    >
                      {metadataService.getButton("Edit")}
                    </small>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <br />
            <FinancialDetails
              employers={employers}
              incomes={incomes}
              onEdit={this.props.onRequestEditFinancialInfo}
              showEdit={true}
            />            
          </div>
        )}
      </div>
    );
  }
}

ViewProfile.propTypes = {
  onRequestEdit: PropTypes.func.isRequired,
  onRequestEditFinancialInfo: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  let {
    profile: { originalProfile, profileLoaded },
  } = state;
  return {
    profile: originalProfile,
    profileLoaded,
    language : state.users.language
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}
const connectedViewProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewProfile);
export { connectedViewProfile as ViewProfile };



// WEBPACK FOOTER //
// ./src/components/subcomponents/ViewProfile.jsx